<template>
    <tr>
        <td class="td-10">
            {{ ip.id }}
        </td>
        <td class="td-15">
            {{ ip.ip }}
        </td>
        <td class="td-20">
            <select-component
                v-if="editItemStatus"
                ref="typeRef"
                :disabled="processing"
                :items="getItemsIpType()"
                :selected="ip.type"
                placeholder="Select type"
                class-main-block="form-group col-xs-12 no-padding"
            />
            <span
                v-else
                :class="classByIpType"
                :title="titleByIpType"
                class="label"
            >
                {{ titleByIpType }}
            </span>
        </td>

        <td class="td-20">
            <select-component
                v-if="editItemStatus"
                ref="groupRef"
                :disabled="processing"
                :items="getItemsIpGroups()"
                :selected="ip.group_id"
                placeholder="Select type"
                class-main-block="form-group col-xs-12 no-padding"
            />
            <span v-else>
                {{ group.name }}
            </span>
        </td>
        <td class="td-15">
            <div class="text-right">
                <button
                    v-if="ip.type !== typeActual"
                    :disabled="processing || editItemStatus"
                    class="btn btn-sm btn-danger"
                    type="button"
                    @click="deleteItem()"
                >
                    <i class="fa fa-trash"></i>
                    <span class="sr-only">Delete</span>
                </button>
                <button
                    v-if="!editItemStatus"
                    :disabled="processing"
                    class="btn btn-sm btn-primary"
                    type="button"
                    @click="setEditMode()"
                >
                    <i class="fa fa-edit"></i>
                    <span class="sr-only">Edit</span>
                </button>
                <a
                    :href="getShowRoute()"
                    :disabled="processing || editItemStatus"
                    @click="preventDefault"
                    @keydown="preventDefault"
                    class="btn btn-sm btn-info"
                >
                    <i class="fa fa-eye"></i>
                    <span class="sr-only">Show</span>
                </a>
                <button
                    v-if="editItemStatus"
                    :disabled="processing"
                    class="btn btn-sm btn-success"
                    type="button"
                    @click="updateItem()"
                >
                    <i class="fa fa-check"></i>
                    <span class="sr-only">Apply</span>
                </button>
                <button
                    v-if="editItemStatus"
                    :disabled="processing"
                    class="btn btn-sm btn-danger"
                    type="button"
                    @click="removeEditMode()"
                >
                    <i class="fa fa-ban"></i>
                    <span class="sr-only">Cancel</span>
                </button>
            </div>
        </td>
    </tr>
</template>

<script>
import EventBus from '../../../../event-bus';
import ipTypes from '../../data/ipTypes';
import routes from '../../data/routes';
export default {
    props: {
        ip: Object,
        ipGroups: Array,
    },
    data() {
        return {
            ipType: 1,
            typeActual: 1,
            processing: false,
            editItemStatus: false,
            ipTypes,
            routes,
        };
    },
    methods: {
        deleteItem() {
            EventBus.$emit('showModalForm', {
                method: 'delete',
                emitUpdateMethod: 'deleteIpModalUpdate',
                route: this.routes.ip.delete.replace(':id', this.ip.id),
                headerText: `Delete IP #${this.ip.id}`,
                bodyHeaderText: `Confirm delete ${this.ip.ip}, please.`,
            });
        },
        updateItem() {
            let self = this;
            self.processing = true;

            let dataRequest = {
                id: this.ip.id,
                ip: this.ip.ip,
                group_id: this.$refs.groupRef.getValue(),
                type: this.$refs.typeRef.getValue(),
            };

            axios
                .put(
                    self.routes.ip.update.replace(':id', self.ip.id),
                    dataRequest
                )
                .then(function (resp) {
                    EventBus.$emit('updateIpDataUpdate', resp.data.data);
                    self.editItemStatus = false;
                })
                .catch((errors) => {
                    self.showErrors(errors);
                })
                .finally(() => {
                    self.processing = false;
                });
        },
        showErrors(errors) {
            let errorData = [];
            if (errors.response.status === 404) {
                errorData.push('This item does not exist');
            } else if (errors.response.status === 422) {
                for (let key in errors.response.data.errors) {
                    errors.response.data.errors[key].forEach((error) => {
                        errorData.push(error);
                    });
                }
            } else {
                errorData.push('Server side error.');
            }

            alert(errorData.join('\n'));
        },
        getItemsIpGroups() {
            return this.ipGroups.map((item) => {
                item.$isDisabled = item.id === this.ip.group_id;
                return item;
            });
        },
        getItemsIpType() {
            return this.ipTypes.map((item) => {
                item.$isDisabled = item.id === this.ip.type;
                return item;
            });
        },
        removeEditMode() {
            this.editItemStatus = false;
        },
        setEditMode() {
            this.editItemStatus = true;
        },
        getShowRoute() {
            return this.routes.ip.show.replace(':id', this.ip.id);
        },
        preventDefault(event) {
            if (this.processing || this.editItemStatus) {
                return event.preventDefault();
            }
        },
    },
    computed: {
        titleByIpType: function () {
            return this.ip.type === 2
                ? 'Used'
                : this.ip.type === 1
                ? 'Actual'
                : 'None';
        },
        classByIpType: function () {
            return this.ip.type === 2
                ? 'bg-red'
                : this.ip.type === 1
                ? 'bg-green'
                : 'bg-gray';
        },
        group: function () {
            return this.ipGroups.find((item) => {
                return item.id === this.ip.group_id;
            });
        },
    },
};
</script>
<style scoped>
.table tr td {
    vertical-align: top;
}
.td-10 {
    width: 10%;
}
.td-15 {
    width: 15%;
}
.td-20 {
    width: 20%;
}
.form-group {
    margin: 0;
}
</style>
